import Turbolinks from 'turbolinks';
import { Amplitude } from './amplitude';
import './google-analytics';

export class Navigation {
	static start() {
		Turbolinks.start();
	}

	static visit(location: string) {
		Turbolinks.visit(location);

		Amplitude.logEvent('Page - View', {
			'Url': window.location.href
		});

		try {
			ga('set', 'page', location);
			ga('send', 'pageview');
		}
		catch (e) { }
	}

	static reload() {
		Turbolinks.visit(window.location.href, { replace: true });
	}
}
